import React from "react";
export default function FullscreenContainer({ children, actions }) {
    return (React.createElement("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "white",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            boxSizing: "border-box",
            overflow: "hidden",
        } },
        React.createElement("div", { style: { flex: 1, minHeight: 0 } }, children),
        actions && (React.createElement("div", { style: { flexShrink: 0, paddingTop: "1rem" } }, actions))));
}
